const ActionKeys = {
    AUTH: {
        CUSTOMERINFO: 'CUSTOMERINFO',
    },
    TOKEN: {
        GET_TOKEN: 'GET_TOKEN',
        GET_EXTERNAL_TOKEN: 'GET_EXTERNAL_TOKEN',
    },
    SELECTEDOPTION: {
        SELECT: 'SELECT',
        SELECT_ADDRESS: 'SELECT_ADDRESS',
        // Personal info
        MARITAL_STATUS: 'MARITAL_STATUS',
        JOBS: 'JOBS',
        ACADEMIC_LEVEL: 'ACADEMIC_LEVEL',
        PLACE_ISSUE_CARD: 'PLACE_ISSUE_CARD',

        // Contact address
        ADDRESS_STATUS: 'ADDRESS_STATUS',
        ADDRESS_LIST: 'ADDRESS_LIST',
        ADDRESS_LIST_EXTRA: 'ADDRESS_LIST_EXTRA',
        LOAN_OBJECT: 'LOAN_OBJECT',
        TYPE_OF_IDENTIFICATION_PAPER: 'TYPE_OF_IDENTIFICATION_PAPER',

        // Reset option
        RESET_OPTION: 'RESET_OPTION',
    },
    LOAN: {
        SAVE_LOAN_DATA: 'SAVE_LOAN_DATA',
    },
    IDENTITY: {
        DATA_IDENTITY: 'DATA_IDENTITY',
    },
    PERSONAL_INFO: {
        SAVE_PERSONAL_INFO: 'SAVE_PERSONAL_INFO',
    },
    MASTER_FLOW: {
        SAVE_MASTER_FLOW: 'SAVE_MASTER_FLOW',
    },
    COMMON: {
        SET_FROM_PAGE: 'SET_FROM_PAGE',
    },

    // Bán hàng pha chế
    ADD_TAB: 'ADD_TAB',
    ORDER_CODE_EDIT: 'ORDER_CODE_EDIT',

    //  Quản lý nhập hàng
    IMPORT_GOODS: {
        ADD_TO_CART: 'ADD_TO_CART',
        UPDATE_CART: 'UPDATE_CART',
        DELETE_TO_CART: 'DELETE_TO_CART',

        GET_DETAIL: 'GET_DETAIL', // chi tiết phiếu nhập
        IS_COPY: 'IS_COPY', // màn copy của phiếu nhập
        OPEN_ADD_PACKAGE: 'OPEN_ADD_PACKAGE', // Mở modal thêm mới package
        GET_EXCHANGE_CODE: "GET_EXCHANGE_CODE"
    },

    EXPORT_GOODS: {
        GET_DETAIL: 'GET_DETAIL', // chi tiết phiếu chuyển
        IS_COPY: 'IS_COPY', // màn copy của phiếu chuyển
        OPEN_ADD_PACKAGE: 'OPEN_ADD_PACKAGE', // Mở modal thêm mới package
    },

    RETURN_GOODS: {
        GET_DETAIL: 'GET_DETAIL', // chi tiết phiếu chuyển
        IS_COPY: 'IS_COPY', // màn copy của phiếu chuyển
    },

    CONFIG_PROMOTION: {
        DETAIL: 'DETAIL',
    },

    // quản lý xuất thẻ
    CANCELLATION_TICKET: {
        GET_DETAIL: 'SAVE_DETAIL',
    },

    // quản lý điều chỉnh
    ADJUSTMENT_TICKET: {
        GET_DETAIL: 'SAVE_DETAIL_ADJUSTMENT',
        GET_DATA_TYPE_TICKET: 'GET_DATA_TYPE_TICKET_ADJUSTMENT',
    },
};

export default ActionKeys;
